<template>
  <div>
    <OnboardingImageSection
      width="100%"
      :image="accountsStructure"
      align="center"
    />

    <OnboardingTextSection>
      Так выглядит порядок структурных элементов<br>
      в Marilyn.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Верхний <b>МСС-аккаунт</b> создается автоматически<br>
      при регистрации в системе и имеет название вашей<br>
      организации.
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';
  import OnboardingImageSection from 'onboarding/onboardings/components/OnboardingImageSection';
  import accountsStructure from 'onboarding/onboardings/AccountsListOnboarding/assets/account-structure.png';

  export default {
    name: 'AccountTypesStep',
    components: {OnboardingImageSection, OnboardingTextSection},
    data () {
      return {
        accountsStructure
      };
    }
  };
</script>
